import { unReadMessageCountServer } from '@/api/message';

const state = {
    totalMessage: 0,
    systemMessageNum: 0,
    privateMessageNum: 0,
};

const getters = {
    totalMessage: (state) => state.totalMessage,
    systemMessageNum: (state) => state.systemMessageNum,
    privateMessageNum: (state) => state.privateMessageNum,
};

const mutations = {
    UPDATE_UNREAD_COUNT: (state, num) => {
        state.totalMessage = num;
    },
    UPDATE_UNREAD_MESSAGE_COUNT: (state, num) => {
        state.systemMessageNum = num;
    },
    UPDATE_UNREAD_PRIVATE_COUNT: (state, num) => {
        state.privateMessageNum = num;
    },
};

const actions = {
    // 更新课程信息
    async getUnReadMessageCount({ commit }) {
        const { code, data } = await unReadMessageCountServer();

        if (code === 0) {
            const privateMessageNum = Number(data.privateMessageNum || 0);
            const systemMessageNum = Number(data.systemMessageNum || 0);
            const totalMessage = systemMessageNum + Number(data.privateMessageNum || 0);

            commit('UPDATE_UNREAD_MESSAGE_COUNT', systemMessageNum);
            commit('UPDATE_UNREAD_PRIVATE_COUNT', privateMessageNum);
            commit('UPDATE_UNREAD_COUNT', totalMessage);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
